import ScrollMagic from "scrollmagic";

const controller = new ScrollMagic.Controller();

export default controller;
